


















































































import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import ImageUploader from '../../files/_components/imageUploader.vue';
import DatePicker from '../../../components/date-picker.vue';

@Component({
  components: {
    DatePicker,
    ImageUploader,
  },
})
export default class DlgCampaignNew extends Vue {
  public $refs!: {
    image: any,
    form: any,
  };

  private dialog: boolean = false;
  private valid: boolean = true;
  private campaign: any = { title: '', subject: '', type: 'external'};
  private loading: boolean = false;

  @Action('campaigns/create') private create!: any;
  @Action('campaigns/read') private readAll!: any;
  @Getter('rules/all') private rules!: any;

  private async save() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      await this.create(this.campaign);
      await this.readAll();
      this.loading = false;
      this.dialog = false;

      this.campaign = { title: '', subject: '', type: 'external'};
      this.$refs.form.reset();

      // TODO: redirect to new campaign
    }
  }
}
